var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9997 0.000357485C4.2889 0.000357485 1.15454 2.96123 0.149174 4.02375C-0.0497246 4.23395 -0.0497246 4.56143 0.149174 4.77163C1.15457 5.83428 4.2889 8.79503 7.9997 8.79503C11.7118 8.79503 14.8468 5.83223 15.8512 4.77033C16.0496 4.56065 16.0496 4.23405 15.8512 4.02437C14.8468 2.9626 11.7118 0 7.9997 0V0.000357485ZM7.9997 8.29053C4.61091 8.29053 1.76542 5.50099 0.971595 4.64471C0.841999 4.50496 0.841999 4.29069 0.971595 4.15097C1.76516 3.29459 4.61091 0.50515 7.9997 0.50515C11.3885 0.50515 14.234 3.29469 15.0278 4.15097C15.1574 4.29072 15.1574 4.50499 15.0278 4.64471C14.2342 5.50109 11.3885 8.29053 7.9997 8.29053Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2903 2.93393C10.1591 3.29097 9.81704 3.54624 9.41441 3.54624C8.89857 3.54624 8.48047 3.12814 8.48047 2.6123C8.48047 2.28684 8.64713 2.00064 8.89948 1.83346C8.6177 1.7347 8.31625 1.67822 8.00083 1.67822C6.49886 1.67822 5.28125 2.89587 5.28125 4.3978C5.28125 5.89973 6.49889 7.11738 8.00083 7.11738C9.50276 7.11738 10.7204 5.89973 10.7204 4.3978C10.7204 3.85824 10.5612 3.35673 10.2904 2.93392L10.2903 2.93393Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEye);
export default __webpack_public_path__ + "static/media/openedEye.1434a0355b85ae3334c38c5f2bda232f.svg";
export { ForwardRef as ReactComponent };